module.exports = __webpack_public_path__ + "img/node-user-transparent.b0111bc7.webp";